import React, { useState } from "react";
import "./Log.css";
import NavBar from "./Navbar";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
export default function Log() {
  const [user, setUser] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    var data = localStorage.getItem("sign");
    if (data) setUser(JSON.parse(data));
  }, []);

  console.log("user", user);

  var navigate = useNavigate();
  const handleloginData = (e) => {
    e.preventDefault();
    const user_name = user.filter((item) => item.email === email);
    console.log("user", user_name);

    if (user_name[0]["password"] === password) {
      alert("login");
      navigate("/");
    } else {
      alert("invalid");
      navigate("/log");
    }
  };
  return (
    <>
      <NavBar />
      <div class="login-box">
        <h2>Login</h2>
        <form onSubmit={(e) => handleloginData(e)}>
          <div class="user-box">
            <input
              type="text"
              onChange={(e) => setEmail(e.target.value)}
              name=""
              required=""
            />
            <label>Email</label>
          </div>
          <div class="user-box">
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              name=""
              required=""
            />
            <label>Password</label>
          </div>
          <button type="submit">Submit</button>
        </form>
      </div>
    </>
  );
}
